export const translate = {
	pt: {
		'Liderazgo': 'Liderança',
		'Capacidad de inspirar y guiar al equipo, y cómo promueve un ambiente colaborativo y de crecimiento.':
			'Capacidade de inspirar e guiar a equipe, promovendo um ambiente colaborativo e de crescimento.',

		'Comunicación': 'Comunicação',
		'Claridad y precisión con que transmite información y su capacidad para escuchar a los demás.':
			'Clareza e precisão na transmissão de informações e sua capacidade de ouvir os outros.',

		'Competencias Técnicas': 'Competências Técnicas',
		'Dominio en la aplicación de conocimientos específicos al trabajo, además de la capacidad para resolver problemas.':
			'Domínio na aplicação de conhecimentos específicos ao trabalho e capacidade para resolver problemas.',

		'Responsabilidad y Compromiso': 'Responsabilidade e Compromisso',
		'Demostración de dedicación y proactividad en sus tareas y proyectos.':
			'Demonstração de dedicação e proatividade em suas tarefas e projetos.',

		'Ética Profesional': 'Ética Profissional',
		'Coherencia entre discurso y acción, y trato profesional y respetuoso con colegas y responsabilidades.':
			'Coerência entre discurso e ação, e tratamento profissional e respeitoso com colegas e responsabilidades.',

		'Relaciones Interpersonales': 'Relações Interpessoais',
		'Capacidad para construir y mantener relaciones positivas y resolver conflictos de manera constructiva.':
			'Capacidade de construir e manter relações positivas e resolver conflitos de forma construtiva.',

		'Desempeño y Resultados': 'Desempenho e Resultados',
		'Consistencia con la que alcanza o supera las metas establecidas y por la calidad e impacto de los resultados.':
			'Consistência ao alcançar ou superar as metas estabelecidas e pela qualidade e impacto dos resultados.',

		'Innovación y Creatividad': 'Inovação e Criatividade',
		'Capacidad para proponer soluciones únicas y originales, y disposición para experimentar nuevas aproximaciones.':
			'Capacidade de propor soluções únicas e originais e disposição para experimentar novas abordagens.',

		'Gestión del Tiempo y Prioridades': 'Gestão do Tempo e Prioridades',
		'Capacidad para cumplir plazos y priorizar tareas de alta importancia.':
			'Capacidade de cumprir prazos e priorizar tarefas de alta importância.',

		'Iniciativa': 'Iniciativa',
		'Disposición para asumir responsabilidades y la búsqueda activa de soluciones y mejoras.':
			'Disposição para assumir responsabilidades e buscar ativamente soluções e melhorias.',

		'Integridad': 'Integridade',
		'Mantener altos estándares éticos, siendo honesto y cumpliendo con responsabilidad todas las obligaciones.':
			'Manter altos padrões éticos, sendo honesto e cumprindo com responsabilidade todas as obrigações.',

		'Adaptabilidad': 'Adaptabilidade',
		'Capacidad para ajustarse rápidamente a nuevas situaciones, cambios y desafíos, manteniendo la eficacia.':
			'Capacidade de se ajustar rapidamente a novas situações, mudanças e desafios, mantendo a eficácia.',

		'Colaboración y Trabajo en Equipo': 'Colaboração e Trabalho em Equipe',
		'Colaborar activamente con colegas y partes interesadas para alcanzar objetivos comunes, promoviendo un ambiente de cooperación.':
			'Colaborar ativamente com colegas e partes interessadas para alcançar objetivos comuns, promovendo um ambiente de cooperação.',

		'Indignación Constructiva': 'Crítica Construtiva',
		'Canalizar sentimientos de insatisfacción para proponer mejoras y soluciones, contribuyendo positivamente a la organización.':
			'Canalizar sentimentos de insatisfação para propor melhorias e soluções, contribuindo positivamente para a organização.',

		'Visión de Riesgo': 'Visão de Risco',
		'Identificar, evaluar y anticipar posibles riesgos, tomando decisiones informadas para mitigarlos de manera eficaz.':
			'Identificar, avaliar e antecipar possíveis riscos, tomando decisões informadas para mitigá-los de forma eficaz.',
	},
	es: {
		'Liderazgo': 'Liderazgo',
		'Capacidad de inspirar y guiar al equipo, y cómo promueve un ambiente colaborativo y de crecimiento.':
			'Capacidad de inspirar y guiar al equipo, y cómo promueve un ambiente colaborativo y de crecimiento.',

		'Comunicación': 'Comunicación',
		'Claridad y precisión con que transmite información y su capacidad para escuchar a los demás.':
			'Claridad y precisión con que transmite información y su capacidad para escuchar a los demás.',

		'Competencias Técnicas': 'Competencias Técnicas',
		'Dominio en la aplicación de conocimientos específicos al trabajo, además de la capacidad para resolver problemas.':
			'Dominio en la aplicación de conocimientos específicos al trabajo, además de la capacidad para resolver problemas.',

		'Responsabilidad y Compromiso': 'Responsabilidad y Compromiso',
		'Demostración de dedicación y proactividad en sus tareas y proyectos.':
			'Demostración de dedicación y proactividad en sus tareas y proyectos.',

		'Ética Profesional': 'Ética Profesional',
		'Coherencia entre discurso y acción, y trato profesional y respetuoso con colegas y responsabilidades.':
			'Coherencia entre discurso y acción, y trato profesional y respetuoso con colegas y responsabilidades.',

		'Relaciones Interpersonales': 'Relaciones Interpersonales',
		'Capacidad para construir y mantener relaciones positivas y resolver conflictos de manera constructiva.':
			'Capacidad para construir y mantener relaciones positivas y resolver conflictos de manera constructiva.',

		'Desempeño y Resultados': 'Desempeño y Resultados',
		'Consistencia con la que alcanza o supera las metas establecidas y por la calidad e impacto de los resultados.':
			'Consistencia con la que alcanza o supera las metas establecidas y por la calidad e impacto de los resultados.',

		'Innovación y Creatividad': 'Innovación y Creatividad',
		'Capacidad para proponer soluciones únicas y originales, y disposición para experimentar nuevas aproximaciones.':
			'Capacidad para proponer soluciones únicas y originales, y disposición para experimentar nuevas aproximaciones.',

		'Gestión del Tiempo y Prioridades': 'Gestión del Tiempo y Prioridades',
		'Capacidad para cumplir plazos y priorizar tareas de alta importancia.':
			'Capacidad para cumplir plazos y priorizar tareas de alta importancia.',

		'Iniciativa': 'Iniciativa',
		'Disposición para asumir responsabilidades y la búsqueda activa de soluciones y mejoras.':
			'Disposición para asumir responsabilidades y la búsqueda activa de soluciones y mejoras.',

		'Integridad': 'Integridad',
		'Mantener altos estándares éticos, siendo honesto y cumpliendo con responsabilidad todas las obligaciones.':
			'Mantener altos estándares éticos, siendo honesto y cumpliendo con responsabilidad todas las obligaciones.',

		'Adaptabilidad': 'Adaptabilidad',
		'Capacidad para ajustarse rápidamente a nuevas situaciones, cambios y desafíos, manteniendo la eficacia.':
			'Capacidad para ajustarse rápidamente a nuevas situaciones, cambios y desafíos, manteniendo la eficacia.',

		'Colaboración y Trabajo en Equipo': 'Colaboración y Trabajo en Equipo',
		'Colaborar activamente con colegas y partes interesadas para alcanzar objetivos comunes, promoviendo un ambiente de cooperación.':
			'Colaborar activamente con colegas y partes interesadas para alcanzar objetivos comunes, promoviendo un ambiente de cooperación.',

		'Indignación Constructiva': 'Indignación Constructiva',
		'Canalizar sentimientos de insatisfacción para proponer mejoras y soluciones, contribuyendo positivamente a la organización.':
			'Canalizar sentimientos de insatisfacción para proponer mejoras y soluciones, contribuyendo positivamente a la organización.',

		'Visión de Riesgo': 'Visión de Riesgo',
		'Identificar, evaluar y anticipar posibles riesgos, tomando decisiones informadas para mitigarlos de manera eficaz.':
			'Identificar, evaluar y anticipar posibles riesgos, tomando decisiones informadas para mitigarlos de manera eficaz.',
	},
}
